import { render, staticRenderFns } from "./BrandComponent.vue?vue&type=template&id=0ac0bf24"
import script from "./BrandComponent.vue?vue&type=script&lang=js"
export * from "./BrandComponent.vue?vue&type=script&lang=js"
import style0 from "./BrandComponent.vue?vue&type=style&index=0&id=0ac0bf24&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports